import script from "./AiSuggestionList.vue?vue&type=script&setup=true&lang=js"
export * from "./AiSuggestionList.vue?vue&type=script&setup=true&lang=js"

import "./AiSuggestionList.vue?vue&type=style&index=0&id=5c907f8d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c907f8d"]])

export default __exports__